import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {CompanyProfileLocationsTableRow, LocationRow} from './CompanyProfileLocationsTableRow';
import {BasicTable} from '../../../../components/BasicTable/BasicTable';
import {createBasicTableColumn} from '../../../../components/BasicTable/createBasicTableColumn';
import {CompanyLocation} from '../../../../types/shared-types';


interface Props {
  locations: CompanyLocation[];
}

export const CompanyProfileLocationsTable = ({locations}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'companyProfile.locations.accordion'});

  const columns = useMemo(
    () => [
      createBasicTableColumn<LocationRow>('city', t('city'), {sx: {width: '22%', minWidth: 0}}),
      createBasicTableColumn<LocationRow>('address', t('street'), {sx: {width: '28%', minWidth: 0}}),
      createBasicTableColumn<LocationRow>('additionalInfo', t('additionalInfo'), {sx: {width: '22%', minWidth: 0}}),
      createBasicTableColumn<LocationRow>('zipCode', t('zipCode'), {sx: {width: '14%', minWidth: 0}}),
      createBasicTableColumn<LocationRow>('country', t('country'), {sx: {width: '14%', minWidth: 0}}),
    ],
    [t]
  );

  const rowData: LocationRow[] = useMemo(
    () =>
      locations.map((location) => ({
        id: location.resourceId,
        city: location.city,
        address: [location.street, location.houseNumber].filter(Boolean).join(' '),
        additionalInfo: location.additionalInfo ?? '',
        zipCode: location.zipCode,
        country: location.country,
      })),
    [locations]
  );

  return (
    <BasicTable<LocationRow>
      columns={columns}
      Row={CompanyProfileLocationsTableRow}
      rowData={rowData}
      hideLoadMoreFooter
    />
  );
};
